/* eslint-disable no-unused-vars */
import application from 'application/application';

const controller = 'LegalPartnerController';

application.controller(controller, [
	'$scope',
	'$timeout',
	'$http',
	'helper',
	'API',
	'$rootScope',
	'permissions',
	async function(
		$scope,
		$timeout,
		$http,
		helper,
		API,
		$rootScope,
		permissions
	) {
		// ---- UI ----
		$scope.loaded = false;
		$scope.loadedDemo = false;
		$scope.error = false;
		$scope.demoError = false;
		$scope.openMenu = false;
		$scope.loadingCredits = false;
		$scope.retrying = false;
		$scope.publishableKey = null;
		$scope.refreshToken = null;
		$scope.controlsCredits = {
			partsCredits: 0,
			contractsCredits: 0
		};
		$scope.demoUrl = null;

		// ---- helpers ----
		let aiElement = null;
		let refreshingPromise = null;
		let errorTimer = null;
		let refreshTimer = null;
		const partsGeneratorFeatureId =
			(permissions.funcionalities &&
				permissions.funcionalities.partsGenerator) ||
			-77;

		function hasPartsGeneratorFeature(features = []) {
			return features.some(
				feature => Number(feature.idFuncionalidade) === partsGeneratorFeatureId
			);
		}

		function hasPartsGeneratorFromSession() {
			const storedFeatures = sessionStorage.userFeatures;

			if (!storedFeatures || storedFeatures === 'undefined') return null;

			try {
				const parsedFeatures = JSON.parse(storedFeatures);

				if (!Array.isArray(parsedFeatures)) return null;

				return hasPartsGeneratorFeature(parsedFeatures);
			} catch (e) {
				return null;
			}
		}

		function validatePartsGeneratorByApi() {
			return $http({
				...helper.http(API.permissions, 'GET'),
				params: {
					...helper.httpFields(['idFuncionalidade']),
					registrosPorPagina: -1,
					ativo: true,
					idFuncionalidade: partsGeneratorFeatureId
				},
				noCancelOnRouteChange: true
			}).then(({ data }) => {
				const functionalities = data.itens || [];

				return hasPartsGeneratorFeature(functionalities);
			});
		}

		function handlePartsGeneratorValidation(hasFeature) {
			if (hasFeature) {
				$scope.loadedDemo = true;
				initPartsGenerator();
			} else {
				$scope.loaded = true;
				initDemoIframe();
			}
		}

		function onInitCode() {
			$scope.loaded = false;
			const hasFeatureInSession = hasPartsGeneratorFromSession();

			if (hasFeatureInSession !== null) {
				handlePartsGeneratorValidation(hasFeatureInSession);

				return;
			}

			validatePartsGeneratorByApi().then(hasFeature =>
				handlePartsGeneratorValidation(hasFeature)
			);
		}

		// === utils de JWT/expiração ===
		function parseJwtExp(token) {
			try {
				const parts = token.split('.');

				if (parts.length < 2) return null;
				const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
				const json = JSON.parse(atob(base64));

				return typeof json.exp === 'number' ? json.exp : null; // segundos
			} catch (e) {
				return null;
			}
		}

		function msUntilRefresh(token, skewSeconds = 30) {
			const exp = parseJwtExp(token);

			if (!exp) return 0; // se não der para ler, force já
			const nowSec = Math.floor(Date.now() / 1000);
			const refreshAt = Math.max(exp - skewSeconds, nowSec);

			return Math.max((refreshAt - nowSec) * 1000, 0);
		}

		function scheduleRefresh(jwtToken) {
			if (refreshTimer) $timeout.cancel(refreshTimer);
			const waitMs = msUntilRefresh(jwtToken, 30); // 30s antes de expirar

			refreshTimer = $timeout(() => {
				refreshTokenFlow().catch(() => {});
			}, waitMs);
		}

		async function refreshTokenFlow() {
			if (refreshingPromise) return refreshingPromise;

			refreshingPromise = $http({
				...helper.http(API.parts, 'refreshToken'),
				method: 'POST',
				data: { refreshToken: $scope.refreshToken },
				messageOverride: {
					success() {}
				}
			})
				.then(({ data }) => {
					const { jwtToken, refreshToken } = data.itens[0];

					if (refreshToken) $scope.refreshToken = refreshToken;

					scheduleRefresh(jwtToken);

					$scope.publishableKey = jwtToken;

					return jwtToken;
				})
				.finally(() => {
					refreshingPromise = null;
					$scope.loaded = true;
				});

			return refreshingPromise;
		}

		async function getToken() {
			if (refreshingPromise) return refreshingPromise;

			refreshingPromise = $http({
				...helper.http(API.parts, 'getToken'),
				method: 'POST'
			})
				.then(({ data }) => {
					const { jwtToken, refreshToken } = data.itens[0];

					$scope.refreshToken = refreshToken;

					scheduleRefresh(jwtToken);

					return jwtToken;
				})
				.finally(() => {
					refreshingPromise = null;
					setTimeout(() => {
						$scope.loaded = true;
					}, 500);
				});

			return refreshingPromise;
		}

		async function initPartsGenerator() {
			try {
				const token = await getToken();

				$scope.publishableKey = token;
				$scope.$applyAsync();

				$timeout(() => {
					aiElement = document.querySelector('ai-integration');
					if (aiElement) {
						aiElement.setAttribute('publishable-key', token);
						attachListeners(aiElement);
					}

					$scope.loadedDemo = true;
				}, 0);
			} catch (e) {
				$scope.error = true;
				$scope.$applyAsync();
				$scope.loadedDemo = true;
			}
		}

		errorTimer = $timeout(function() {
			if (!$scope.loaded) $scope.error = true;
		}, 10000);

		function applyNewToken(newToken) {
			$scope.publishableKey = newToken;
			if (aiElement) {
				aiElement.setAttribute('publishable-key', newToken);
				recreateAiElement();
			}
			$scope.$applyAsync();
		}

		function recreateAiElement() {
			if (!aiElement || !aiElement.parentNode) return;
			const parent = aiElement.parentNode;
			const clone = aiElement.cloneNode(false);

			clone.setAttribute('publishable-key', $scope.publishableKey);
			detachListeners(aiElement);
			parent.replaceChild(clone, aiElement);
			aiElement = clone;
			attachListeners(aiElement);
		}

		async function handleLoaded() {
			$scope.error = false;
			if (errorTimer) {
				$timeout.cancel(errorTimer);
				errorTimer = null;
			}
			$scope.$applyAsync();
		}

		async function handleTokenRevoked() {
			try {
				const newToken = await refreshTokenFlow();

				applyNewToken(newToken);
			} catch (e) {
				try {
					const fallback = await getToken();

					applyNewToken(fallback);
				} catch (e) {
					$scope.error = true;
					$scope.$applyAsync();
					$timeout(handleTokenRevoked, 3000);
				}
			}
		}

		async function forceCreateOrUpdate(token) {
			$scope.publishableKey = token;
			$scope.loaded = false;
			$scope.error = false;
			$scope.$applyAsync();

			if (errorTimer) $timeout.cancel(errorTimer);
			errorTimer = $timeout(() => {
				if (!$scope.loaded) $scope.error = true;
			}, 10000);

			$timeout(() => {
				aiElement = document.querySelector('ai-integration');
				if (aiElement) {
					aiElement.setAttribute('publishable-key', token);
					detachListeners(aiElement);
					attachListeners(aiElement);
				}
			}, 0);
		}

		$scope.myAccountOpened = () => {
			$scope.$applyAsync();

			return $rootScope.exitSubMenu;
		};

		$scope.retry = async function retry() {
			if ($scope.retrying) return;
			$scope.retrying = true;
			$scope.error = false;
			$scope.loaded = false;
			$scope.$applyAsync();

			try {
				const token = await getToken();

				await forceCreateOrUpdate(token);
			} catch (e) {
				$scope.error = true;
			} finally {
				$scope.retrying = false;
				$scope.$applyAsync();
			}
		};

		$scope.openMenuCredit = () => {
			$scope.openMenu = !$scope.openMenu;

			$scope.getCredits();
		};

		$scope.getCredits = () => {
			let refreshingPromise = null;

			if ($scope.loadingCredits && refreshingPromise) return refreshingPromise;

			$scope.loadingCredits = true;

			refreshingPromise = $http({
				...helper.http(API.parts, 'getCredits'),
				method: 'PUT'
			})
				.then(({ data }) => {
					const funcionalidades = data.itens[0].funcionalidades || [];

					const byId = new Map(
						funcionalidades.map(f => [f.idFuncionalidade, f])
					);

					const partsFunc = byId.get(-78);
					const contractsFunc = byId.get(-79);

					const toCredit = f => {
						if (!f) return 0;
						if (f.ilimitado === true) return 'Créditos ilimitados';
						if (typeof f.quantidade === 'number') return f.quantidade;

						return 0;
					};

					const toName = f => {
						if (!f) return '';
						if (typeof f.nomeFuncionalidade === 'string')
							return f.nomeFuncionalidade;

						return '';
					};

					$scope.controlsCredits = {
						partsCredits: toCredit(partsFunc),
						contractsCredits: toCredit(contractsFunc),
						nomeFuncionalidadeParts: toName(partsFunc),
						nomeFuncionalidadeContracts: toName(contractsFunc)
					};

					return data;
				})
				.catch(() => {
					$scope.openMenu = false;
					$scope.loadingCredits = false;
				})
				.finally(() => {
					$scope.loadingCredits = false;
				});

			return refreshingPromise;
		};

		$scope.getCreditsText = type => {
			let cc = $scope.controlsCredits.contractsCredits;
			let cp = $scope.controlsCredits.partsCredits;

			if (type == 'c') {
				let plural = typeof cc === 'number' && cc > 1;
				let pluralText = plural ? 's' : '';

				if (typeof cc === 'string') return cc;

				return `${cc} crédito${pluralText} restante${pluralText}`;
			} else {
				let plural = typeof cc === 'number' && cc > 1;
				let pluralText = plural ? 's' : '';

				if (typeof cp === 'string') return cp;

				return `${cp} crédito${pluralText} restante${pluralText}`;
			}
		};

		$scope.openConsultMoreCredits = () => {
			$('body').addClass('consultant-form-modal-open');

			$('#modalHubFormLabelCreditos')
				.off('hidden.bs.modal.consultantForm')
				.on('hidden.bs.modal.consultantForm', () => {
					$('body').removeClass('consultant-form-modal-open');
				})
				.modal('show');
		};

		function attachListeners(el) {
			el.addEventListener('ai:loaded', handleLoaded);
			el.addEventListener('ai:tokenrevoked', handleTokenRevoked);
		}

		function detachListeners(el) {
			el.removeEventListener('ai:loaded', handleLoaded);
			el.removeEventListener('ai:tokenrevoked', handleTokenRevoked);
		}

		let demoIframe = null;
		let demoLoadHandler = null;
		let demoErrorTimer = null;

		function initDemoIframe() {
			$timeout(() => {
				$scope.$applyAsync(() => {
					$scope.loadedDemo = true;
					$scope.demoError = false;
				});
			}, 500);
		}

		$scope.openModalAddMod = () => {
			$('body').addClass('consultant-form-modal-open');

			$('#modalHubForm')
				.off('hidden.bs.modal.consultantForm')
				.on('hidden.bs.modal.consultantForm', () => {
					$('body').removeClass('consultant-form-modal-open');
				})
				.modal('show');
		};

		$scope.goBackUrl = () => {
			window.history.back();
		};

		// limpeza
		$scope.$on('$destroy', function() {
			if (aiElement) detachListeners(aiElement);
			if (errorTimer) $timeout.cancel(errorTimer);
			if (refreshTimer) $timeout.cancel(refreshTimer);

			if (demoIframe && demoLoadHandler) {
				demoIframe.removeEventListener('load', demoLoadHandler);
			}
			if (demoErrorTimer) $timeout.cancel(demoErrorTimer);
		});

		$(document).on('click', function(e) {
			if ($(e.target).is('.clickout-credits')) {
				$scope.openMenu = false;
				$scope.loadingCredits = false;
				$scope.$applyAsync();
			}
		});

		onInitCode();
	}
]);

export default controller;
